import { api } from '../../lib/apiClient';

// PausePayload is whatever the tool that paused the run emitted. For
// request_human_review it carries { title, report_md, payload }. Other
// callers may shape it differently; we render the well-known keys and
// fall back to a raw JSON view for the rest.
export type PausePayload = {
  title?: string;
  report_md?: string;
  payload?: Record<string, unknown>;
  // Allow arbitrary extras.
  [k: string]: unknown;
};

export type PausedRun = {
  id: string;
  agent_id: string;
  agent_name: string;
  agent_template: string;
  objective: string;
  pause_title: string;
  pause_payload: PausePayload;
  paused_at: string;
  created_at: string;
};

export async function listReviews(orgId: string, limit = 50): Promise<PausedRun[]> {
  const res = await api.get<{ data: { items: PausedRun[] } }>(
    `/v1/orgs/${orgId}/reviews?limit=${limit}`,
  );
  return res.data.data?.items ?? [];
}

export async function getReview(orgId: string, runId: string): Promise<PausedRun> {
  const res = await api.get<{ data: PausedRun }>(
    `/v1/orgs/${orgId}/reviews/${runId}`,
  );
  return res.data.data;
}

// resumeReview resolves a paused run with the reviewer's verdict. The
// backend injects {decision, notes, reviewer_id, ...} as the synthetic
// tool_result for the pause-triggering tool call; the LLM continues
// from there.
export async function resumeReview(
  orgId: string,
  runId: string,
  input: { decision: 'allow' | 'block' | string; notes?: string; extra?: Record<string, unknown> },
): Promise<void> {
  await api.post(`/v1/orgs/${orgId}/reviews/${runId}/resume`, input);
}
